import { isRouteErrorResponse, useRouteError } from "react-router";
import { describeError } from "@/api/client";
import { Button, ButtonLink, EmptyState, InlineAlert } from "@/components";
import styles from "./pages.module.css";

/** Shown inside the layout when a page throws while rendering or loading. */
export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  const message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : describeError(error);
  return (
    <div className={styles.page}>
      <InlineAlert
        tone="danger"
        title="This page hit an error"
        action={<Button onClick={() => window.location.reload()}>Reload page</Button>}
      >
        {message}
      </InlineAlert>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <EmptyState
        title="Page not found"
        description="The address may be mistyped, or the page moved. Use the search (Cmd/Ctrl+K) or the sidebar to find what you need."
        actions={<ButtonLink to="/">Go to the dashboard</ButtonLink>}
      />
    </div>
  );
}
